import { apiRequest } from '@/utils/api-request';

export interface RunMetricsExportFilters {
  start_date: string; // YYYY-MM-DD
  end_date: string; // YYYY-MM-DD
  include_cost?: boolean;
  include_aggregates?: boolean;
  status_filter?: string[];
  workflow_ids?: string[];
  categories?: string[];
  owner_ids?: string[];
  runner_ids?: string[];
  label_ids?: string[];
}

export interface RunMetricsExportStartResponse {
  export_id: string;
  message?: string;
}

export interface RunMetricsExportStatusResponse {
  export_id: string;
  status: 'running' | 'completed' | 'failed';
  row_count?: number;
  download_url?: string | null;
  error?: string | null;
  created_at?: string | null;
  completed_at?: string | null;
  filters?: RunMetricsExportFilters | null;
}

export interface RunMetricsExportListResponse {
  exports: RunMetricsExportStatusResponse[];
}

const baseUrl = (orgId: string) =>
  `/api/v1/orgs/${orgId}/admin/metrics/runs/export`;

export const startRunMetricsExport = async (
  orgId: string,
  filters: RunMetricsExportFilters,
): Promise<RunMetricsExportStartResponse> => {
  const response = await apiRequest<RunMetricsExportStartResponse>({
    url: baseUrl(orgId),
    method: 'POST',
    body: filters as unknown as Record<string, unknown>,
    target: 'workflow',
  });

  if (response.detail) throw new Error(response.detail);
  if (!response.data) throw new Error('Unexpected empty response');
  return response.data;
};

export const getRunMetricsExportStatus = async (
  orgId: string,
  exportId: string,
): Promise<RunMetricsExportStatusResponse> => {
  const response = await apiRequest<RunMetricsExportStatusResponse>({
    url: `${baseUrl(orgId)}/${exportId}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) throw new Error(response.detail);
  if (!response.data) throw new Error('Unexpected empty response');
  return response.data;
};

export const listRunMetricsExports = async (
  orgId: string,
): Promise<RunMetricsExportListResponse> => {
  const response = await apiRequest<RunMetricsExportListResponse>({
    url: baseUrl(orgId),
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) throw new Error(response.detail);
  if (!response.data) throw new Error('Unexpected empty response');
  return response.data;
};
